import { APP_INITIALIZER, ErrorHandler, Provider } from '@angular/core'
import { AuthService } from './auth.service'

/**
 * Finishes a Microsoft sign-in when the app starts on the page Microsoft
 * redirected back to (AuthService.completeMicrosoftSignIn).
 *
 * Angular runs app initializers once every module is built and its error
 * handler is listening, so the `app` Apollo client exists and a failure
 * reaches the global error handler: shown to the user and reported. Startup
 * does not wait for the server: the login page paints, then the answer
 * navigates on.
 *
 * An exported function on purpose: the AOT compiler keeps `useFactory: fn`
 * but drops a factory written as a method (`useFactory(deps) {...}`), which
 * then provides `undefined` (as GraphQLModule's APOLLO_OPTIONS does).
 */
export function completeMicrosoftSignInOnStart(
  auth: AuthService,
  errorHandler: ErrorHandler,
): () => void {
  return () => {
    auth.completeMicrosoftSignIn().catch((e) => errorHandler.handleError(e))
  }
}

export const MICROSOFT_SIGN_IN_INITIALIZER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: completeMicrosoftSignInOnStart,
  deps: [AuthService, ErrorHandler],
  multi: true,
}
